"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExtendedProperties = getExtendedProperties;
const chain_1 = require("../../common/calculations/chain");
function getExtendedProperties(options, baseTypeClassMetadata, typeMetadata) {
    const extendProperties = options.extendProperties ?? true;
    let extendedProperties;
    if (extendProperties) {
        extendedProperties = new Map((0, chain_1.chain)(baseTypeClassMetadata.properties, typeMetadata.properties));
    }
    else {
        extendedProperties = typeMetadata.properties;
    }
    return extendedProperties;
}
//# sourceMappingURL=getExtendedProperties.js.map